import Vue from 'vue';
import vhtml from 'vhtml-ui';
import App from './App.vue';

import 'src/utils/ajax';
import i18n from 'src/i18n';
import { applyLibLocale, onLibLocaleChange } from 'src/utils/lib-locale-bridge/apply-lib-locale';

Vue.use(vhtml);

const sprites = require.context('src/assets/icons', true, /[^.]+\.svg$/);
vhtml.Icon.addSprites(sprites);

onLibLocaleChange(() => location.reload());

applyLibLocale().then(() => {
    document.title = i18n.t('公众号设置-关键词');

    // eslint-disable-next-line no-new
    new Vue({
        el: '#app',
        i18n,
        render: h => h(App),
    });
});
